'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ImagePlaceholderFrame = function () {
  function ImagePlaceholderFrame(element, args) {
    _classCallCheck(this, ImagePlaceholderFrame);

    this.div = document.createElement('div');
    this.div.className = 'imagePlaceholder';

    this.setTitle(args.title);

    var fragment = document.createDocumentFragment();
    fragment.appendChild(this.div);

    if (element) {
      element.appendChild(fragment);
    }
  }

  _createClass(ImagePlaceholderFrame, [{
    key: 'getTitle',
    value: function getTitle() {
      return this.div.innerHTML;
    }
  }, {
    key: 'setTitle',
    value: function setTitle(title) {
      var display = title;

      if (!display) {
        display = '?';
      }

      var pos = 0;
      var r = Math.floor(display.charCodeAt(pos) % 26 * 10);

      if (display.length > 1) {
        pos = 1;
      }

      var g = 192; // Math.floor((title.charCodeAt(pos) % 26) * 7) + 32

      if (display.length > 2) {
        pos = 2;
      }

      var b = Math.floor(display.charCodeAt(pos) % 26 * 6);

      this.div.style.backgroundColor = 'rgb(' + r + ', ' + g + ', ' + b + ')';
      this.div.innerHTML = display.substring(0, 1).toUpperCase();
    }
  }, {
    key: 'getElement',
    value: function getElement() {
      return this.div;
    }
  }]);

  return ImagePlaceholderFrame;
}();

exports.default = ImagePlaceholderFrame;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ui/ImagePlaceholderFrame.js
// module id = 24
// module chunks = 0